import Util from "./Util.js";
import { gsap } from "./Util.js";

class Customer extends Util {
  constructor() {
    super();

    this.init();
  }

  init() {
    if (document.getElementById("toggle-addresses") !== null) {
      this.toggleAddress();
    }
  }

  toggleAddress() {
    const customerAccountPage = document.querySelector(".customer.account");
    const addressesWrapper = customerAccountPage.querySelector(".addresses");
    const accountAdress = customerAccountPage.querySelector(".account-adress");
    const addressAdd = accountAdress.querySelectorAll(".cell .r .edit");
    const addressAddForm = customerAccountPage.querySelector(".address-form.address-add");
    const addressEditList = customerAccountPage.querySelector(".address-edit-list");
    const addressEditForm = addressEditList.querySelectorAll(".address-edit-list .address-form");
    const resetButton = addressEditList.querySelectorAll(".reset");

    for (let i = 0; i < addressAdd.length; i++) {
      const element = addressAdd[i];

      element.addEventListener("click", () => {
        gsap.to(addressesWrapper, {
          opacity: 0,
          duration: 0.15,
          ease: "none",
          onComplete: () => {
            for (let j = 0; j < addressEditForm.length; j++) {
              addressEditForm[j].style.display = "none";
            }
            addressAddForm.style.display = "none";
            addressEditForm[i].style.display = "block";
            addressEditList.style.position = "relative";

            gsap.to(addressesWrapper, {
              opacity: 1,
              duration: 0.15,
              delay: 0.3,
              ease: "none",
            });

            if (!this.website.isDesktop) {
              const toScroll = document.querySelector(".addresses").getBoundingClientRect().top;
              window.SCROLL_INSTANCE.lenis.scrollTo(toScroll + window.pageYOffset - 100);
            }
          },
        });
      });
    }

    for (let i = 0; i < resetButton.length; i++) {
      const element = resetButton[i];

      element.addEventListener("click", () => {
        gsap.to(addressesWrapper, {
          opacity: 0,
          duration: 0.15,
          ease: "none",
          onComplete: () => {
            for (let j = 0; j < addressEditForm.length; j++) {
              addressEditForm[j].style.display = "none";
            }
            addressAddForm.style.display = "block";
            addressEditList.style.position = "absolute";

            gsap.to(addressesWrapper, {
              opacity: 1,
              duration: 0.15,
              delay: 0.3,
              ease: "none",
            });
          },
        });
      });
    }
  }
}

export default Customer;
